"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _statistic = require("@/api/statistic");
var _index = _interopRequireDefault(require("@/components/echartsNew/index"));
var _newToExcel = _interopRequireDefault(require("@/utils/newToExcel.js"));
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//表格导出方法
// 权限判断函数
var _default = exports.default = {
  components: {
    echartsNew: _index.default
  },
  data: function data() {
    return {
      spinShow: false,
      grid: {
        xl: 8,
        lg: 8,
        md: 8,
        sm: 24,
        xs: 24
      },
      options: this.$timeOptions,
      name: "近30天",
      timeVal: [],
      fromList: this.$constants.timeList,
      dateLimit: '',
      dateLimitPram: {},
      list: [],
      optionData: {},
      style: {
        height: "400px"
      },
      pickerOptions: this.$timeOptions
    };
  },
  created: function created() {
    var end = new Date();
    var start = new Date();
    start.setTime(start.setTime(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 29)));
    this.timeVal = [start, end];
  },
  mounted: function mounted() {
    this.dateLimit = 'lately7';
    this.dateLimitPram = 'lately7';
    this.getStatistics();
    this.getTrend();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.$set(this, 'dateLimitPram', e ? this.timeVal.join(",") : "");
    },
    selectChange: function selectChange(limit) {
      if (limit == '') {
        //昨天的时间
        var day1 = new Date();
        var day2 = new Date();
        day1.setTime(day1.getTime() - 48 * 60 * 60 * 1000);
        day2.setTime(day2.getTime() - 24 * 60 * 60 * 1000);
        var s1 = day1.getFullYear() + "-" + (day1.getMonth() + 1) + "-" + day1.getDate();
        var s2 = day2.getFullYear() + "-" + (day2.getMonth() + 1) + "-" + day2.getDate();
        this.dateLimitPram = "".concat(s1, ",").concat(s2);
        this.getTrend();
        this.getStatistics();
      } else {
        this.dateLimitPram = limit;
        this.getTrend();
        this.getStatistics();
      }
    },
    onSeach: function onSeach() {
      this.getStatistics();
      this.getTrend();
    },
    exports: function () {
      var _exports = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var th, filekey, data, fileName, lebData;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              th = [], filekey = [], data = [], fileName = "";
              _context.n = 1;
              return this.getExcelData();
            case 1:
              lebData = _context.v;
              //表格主要数据
              if (!fileName) fileName = '交易统计表'; //文件名
              if (!filekey.length) {
                filekey = lebData.filekey;
              }
              if (!th.length) th = lebData.header; //表头
              data = data.concat(lebData.exportData);
              (0, _newToExcel.default)(th, filekey, fileName, data);
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function exports() {
        return _exports.apply(this, arguments);
      }
      return exports;
    }(),
    getExcelData: function getExcelData(excelData) {
      var _this = this;
      return new Promise(function (resolve, reject) {
        (0, _statistic.tradeTrendApi)({
          dateLimit: _this.dateLimitPram
        }).then(function (res) {
          var header = ['日期/时间', '营业额', "商品支付金额", '充值金额', '支出金额'];
          var filekey = ['date', 'turnover', 'proPayAmount', 'rechargeAmount', 'payoutAmount'];
          var exportData = new Array();
          exportData = res.map(function (item) {
            return {
              date: item.date,
              turnover: item.turnover,
              proPayAmount: item.proPayAmount,
              rechargeAmount: item.rechargeAmount,
              payoutAmount: item.payoutAmount
            };
          });
          resolve({
            header: header,
            filekey: filekey,
            exportData: exportData
          });
        });
      });
    },
    // 统计
    getStatistics: function getStatistics() {
      var _this2 = this;
      (0, _statistic.tradeOverviewApi)({
        dateLimit: this.dateLimitPram
      }).then(function (res) {
        var list = [{
          name: "营业额",
          icon: "iconyingyee1",
          info: '商品支付金额、充值金额、购买付费会员金额、线下收银金额',
          color: '#1890FF',
          class: 'one',
          list: {
            num: res.turnover,
            percent: res.turnoverRatio
          }
        }, {
          name: "商品支付金额",
          icon: "iconshangpinzhifujine1",
          info: '选定条件下，用户购买商品的实际支付金额，包括微信支付、余额支付、支付宝支付、线下支付金额（拼团商品在成团之后计入，线下支付订单在后台确认支付后计入）',
          color: '#A277FF',
          class: 'two',
          list: {
            num: res.proPayAmount,
            percent: res.proPayAmountRatio
          }
        }, {
          name: "充值金额",
          icon: "iconchongzhijine",
          info: '选定条件下，用户成功充值的金额',
          color: '#EF9C20',
          class: 'three',
          list: {
            num: res.rechargeAmount,
            percent: res.rechargeAmountRatio
          }
        }, {
          name: "支出金额",
          icon: "iconzhichujine1",
          info: '余额支付金额、支付佣金金额、商品退款金额',
          color: '#1BBE6B',
          class: 'four',
          list: {
            num: res.payoutAmount,
            percent: res.payoutAmountRatio
          }
        }, {
          name: "余额支付金额",
          icon: "iconyuezhifujine1",
          info: '用户下单时使用余额实际支付的金额',
          color: '#4BCAD5',
          class: 'five',
          list: {
            num: res.balanceAmount,
            percent: res.balanceAmountRatio
          }
        }, {
          name: "支付佣金金额",
          icon: "iconzhifuyongjinjine1",
          info: '后台给推广员支付的推广佣金，以实际支付为准',
          color: '#EF9C20',
          class: 'six',
          list: {
            num: res.payoutBrokerageAmount,
            percent: res.payoutBrokerageAmountRatio
          }
        }, {
          name: "商品退款金额",
          icon: "iconshangpintuikuanjine",
          info: '用户成功退款的商品金额',
          color: '#1890FF',
          class: 'one',
          list: {
            num: res.proRefundAmount,
            percent: res.proRefundAmountRatio
          }
        }];
        _this2.list = list.map(function (item) {
          return {
            name: item.name,
            icon: item.icon,
            list: item.list,
            info: item.info,
            color: item.color,
            class: item.class,
            ratio: item.list.percent.replace("%", "") / 100
          };
        });
      });
    },
    // 统计图
    getTrend: function getTrend() {
      var _this3 = this;
      (0, _statistic.tradeTrendApi)({
        dateLimit: this.dateLimitPram
      }).then(function (res) {
        var xAxis = new Array();
        var series = [{
          "name": "营业额",
          "data": [],
          "type": "line",
          "smooth": "true",
          "yAxisIndex": 0
        }, {
          "name": "商品支付金额",
          "data": [],
          "type": "line",
          "smooth": "true",
          "yAxisIndex": 0
        }, {
          "name": "充值金额",
          "data": [],
          "type": "line",
          "smooth": "true",
          "yAxisIndex": 0
        }, {
          "name": "支出金额",
          "data": [],
          "type": "line",
          "smooth": "true",
          "yAxisIndex": 0
        }];
        xAxis = res.map(function (item) {
          return item.date;
        });
        series[0].data = res.map(function (item) {
          return item.turnover;
        });
        series[1].data = res.map(function (item) {
          return item.proPayAmount;
        });
        series[2].data = res.map(function (item) {
          return item.rechargeAmount;
        });
        series[3].data = res.map(function (item) {
          return item.payoutAmount;
        });
        _this3.spinShow = true;
        var legend = series.map(function (item) {
          return item.name;
        });
        var col = ["#B37FEB", "#FFAB2B", "#1890FF", "#00C050"];
        series.map(function (item, index) {
          item.itemStyle = {
            normal: {
              color: col[index]
            }
          };
        });
        _this3.optionData = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          legend: {
            x: 'center',
            data: legend
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: true,
            // axisTick:{
            //     show:false
            // },
            // axisLine:{
            //     show:false
            // },
            // splitLine: {
            //     show: false
            // },
            axisLabel: {
              interval: 0,
              rotate: 40,
              textStyle: {
                color: '#000000'
              }
            },
            data: xAxis
          },
          yAxis: {
            type: 'value',
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: '#7F8B9C'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#F5F7F9'
              }
            }
          },
          series: series
        };
        _this3.spinShow = false;
      });
    }
  }
};